export default __webpack_public_path__ + "static/media/hiphop_90bpm.f36e55fa.mp3";